module.exports = __webpack_public_path__ + "img/rastro.9495cacc.png";